import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

// import monitorReducersEnhancer from './enhancers/monitor_reducer';
// import loggerMiddleware from './middleware/logger';
import rootReducer from './reducers';

const configureAppStore = (preloadedState) => {
	const store = configureStore({
		reducer: rootReducer,
		middleware: [
            // loggerMiddleware,
            ...getDefaultMiddleware({
                serializableCheck: false
            })
        ],
		preloadedState
		// enhancers: [monitorReducersEnhancer]
	});

	if (process.env.NODE_ENV !== 'production' && module.hot) {
		module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
	}

	return store;
}

export default configureAppStore;
